import React, { useState } from 'react';
function Shared100toGPA5() {
    const [originalGrade, setOriginalGrade] = useState('');
    const [convertedGPA, setConvertedGPA] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const grade = parseFloat(originalGrade);
        if (!isNaN(grade) && grade >= 0 && grade <= 100) {
            let calculatedGPA = '';
            if (grade >= 100) {
                calculatedGPA = '4.95 ~ 5.00';
            } else if (grade >= 99) {
                calculatedGPA = '4.90 ~ 4.94';
            } else if (grade >= 98) {
                calculatedGPA = '4.84 ~ 4.89';
            } else if (grade >= 97) {
                calculatedGPA = '4.79 ~ 4.83';
            } else if (grade >= 96) {
                calculatedGPA = '4.73 ~ 4.78';
            } else if (grade >= 95) {
                calculatedGPA = '4.68 ~ 4.72';
            } else if (grade >= 94) {
                calculatedGPA = '4.62 ~ 4.67';
            } else if (grade >= 93) {
                calculatedGPA = '4.57 ~ 4.61';
            } else if (grade >= 92) {
                calculatedGPA = '4.51 ~ 4.56';
            } else if (grade >= 91) {
                calculatedGPA = '4.45 ~ 4.50';
            } else if (grade >= 90) {
                calculatedGPA = '4.34 ~ 4.44';
            } else if (grade >= 89) {
                calculatedGPA = '4.23 ~ 4.33';
            } else if (grade >= 88) {
                calculatedGPA = '4.12 ~ 4.22';
            } else if (grade >= 87) {
                calculatedGPA = '4.01 ~ 4.11';
            } else if (grade >= 86) {
                calculatedGPA = '3.90 ~ 4.00';
            } else if (grade >= 85) {
                calculatedGPA = '3.79 ~ 3.89';
            } else if (grade >= 84) {
                calculatedGPA = '3.68 ~ 3.78';
            } else if (grade >= 83) {
                calculatedGPA = '3.57 ~ 3.67';
            } else if (grade >= 82) {
                calculatedGPA = '3.45 ~ 3.56';
            } else if (grade >= 81) {
                calculatedGPA = '3.34 ~ 3.44';
            } else if (grade >= 80) {
                calculatedGPA = '3.23 ~ 3.33';
            } else if (grade >= 79) {
                calculatedGPA = '3.12 ~ 3.22';
            } else if (grade >= 78) {
                calculatedGPA = '3.01 ~ 3.11';
            } else if (grade >= 77) {
                calculatedGPA = '2.90 ~ 3.00';
            } else if (grade >= 76) {
                calculatedGPA = '2.79 ~ 2.89';
            } else if (grade >= 75) {
                calculatedGPA = '2.68 ~ 2.78';
            } else if (grade >= 74) {
                calculatedGPA = '2.57 ~ 2.67';
            } else if (grade >= 73) {
                calculatedGPA = '2.46 ~ 2.56';
            } else if (grade >= 72) {
                calculatedGPA = '2.35 ~ 2.45';
            } else if (grade >= 71) {
                calculatedGPA = '2.24 ~ 2.34';
            } else if (grade >= 70) {
                calculatedGPA = '2.13 ~ 2.23';
            } else if (grade >= 69) {
                calculatedGPA = '2.02 ~ 2.12';
            } else if (grade >= 68) {
                calculatedGPA = '1.92 ~ 2.01';
            } else if (grade >= 67) {
                calculatedGPA = '1.82 ~ 1.91';
            } else if (grade >= 66) {
                calculatedGPA = '1.71 ~ 1.81';
            } else if (grade >= 65) {
                calculatedGPA = '1.60 ~ 1.70';
            } else if (grade >= 64) {
                calculatedGPA = '1.50 ~ 1.59';
            } else if (grade >= 63) {
                calculatedGPA = '1.40 ~ 1.49';
            } else if (grade >= 62) {
                calculatedGPA = '1.31 ~ 1.39';
            } else if (grade >= 61) {
                calculatedGPA = '1.21 ~ 1.30';
            } else if (grade >= 60) {
                calculatedGPA = '1.11 ~ 1.20';
            } else {
                calculatedGPA = '0.00 ~ 1.10';
            }
            setConvertedGPA(calculatedGPA);
            setShowResult(true);
            setError(null);
        } else {
            setError('ادخل قيمة صحيحة بين 0 و 100');
            setShowResult(false);
        }
    };
    return (
        <div className="rtl">
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>حول المعدل المئوي من 100 إلى 5</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor='originalGrade'>الدرجة على مئوية 100:</label></b>
                        <input
                            type="text"
                            value={originalGrade}
                            id='originalGrade'
                            onChange={(e) => setOriginalGrade(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                    احسب                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                    {showResult &&  (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>النتائج:</strong>
                            </div>
                            <b>المعدل التراكمي: {convertedGPA}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default Shared100toGPA5;
